export const DATE_TIME_FORMATS = [
  'MMDD hh:mm a',
  'MM/DD hh:mm a',
  'M/DD hh:mm a',
  'MM/D hh:mm a',
  'M/D hh:mm a',
  'MM-DD hh:mm a',
  'M-DD hh:mm a',
  'MM-D hh:mm a',
  'M-D hh:mm a',
  'MM/DD/YY hh:mm a',
  'M/DD/YY hh:mm a',
  'MM/D/YY hh:mm a',
  'M/D/YY hh:mm a',
  'MM-DD-YY hh:mm a',
  'M-DD-YY hh:mm a',
  'MM-D-YY hh:mm a',
  'M-D-YY hh:mm a',
  'MM.DD.YY hh:mm a',
  'M.DD.YY hh:mm a',
  'MM.D.YY hh:mm a',
  'M.D.YY hh:mm a',
  'MMDDYY hh:mm a',
  'MMM D hh:mm a',
  'MMM DD hh:mm a',
  'MMM D YY hh:mm a',
  'MMM DD YY hh:mm a',
  'MMM D, YY hh:mm a',
  'MMM DD, YY hh:mm a',
  'MM/DD/YYYY hh:mm a',
  'M/DD/YYYY hh:mm a',
  'MM/D/YYYY hh:mm a',
  'M/D/YYYY hh:mm a',
  'MM-DD-YYYY hh:mm a',
  'M-DD-YYYY hh:mm a',
  'MM-D-YYYY hh:mm a',
  'M-D-YYYY hh:mm a',
  'MM.DD.YYYY hh:mm a',
  'M.DD.YYYY hh:mm a',
  'MM.D.YYYY hh:mm a',
  'M.D.YYYY hh:mm a',
  'MMDDYYYY hh:mm a',
  'MMM D YYYY hh:mm a',
  'MMM DD YYYY hh:mm a',
  'MMM D, YYYY hh:mm a',
  'MMM DD, YYYY hh:mm a',
  'MMDD h:mm a',
  'MM/DD h:mm a',
  'M/DD h:mm a',
  'MM/D h:mm a',
  'M/D h:mm a',
  'MM-DD h:mm a',
  'M-DD h:mm a',
  'MM-D h:mm a',
  'M-D h:mm a',
  'MM/DD/YY h:mm a',
  'M/DD/YY h:mm a',
  'MM/D/YY h:mm a',
  'M/D/YY h:mm a',
  'MM-DD-YY h:mm a',
  'M-DD-YY h:mm a',
  'MM-D-YY h:mm a',
  'M-D-YY h:mm a',
  'MM.DD.YY h:mm a',
  'M.DD.YY h:mm a',
  'MM.D.YY h:mm a',
  'M.D.YY h:mm a',
  'MMDDYY h:mm a',
  'MMM D h:mm a',
  'MMM DD h:mm a',
  'MMM D YY h:mm a',
  'MMM DD YY h:mm a',
  'MMM D, YY h:mm a',
  'MMM DD, YY h:mm a',
  'MM/DD/YYYY h:mm a',
  'M/DD/YYYY h:mm a',
  'MM/D/YYYY h:mm a',
  'M/D/YYYY h:mm a',
  'MM-DD-YYYY h:mm a',
  'M-DD-YYYY h:mm a',
  'MM-D-YYYY h:mm a',
  'M-D-YYYY h:mm a',
  'YYYY.MM.DD h:mm a',
  'MM.DD.YYYY h:mm a',
  'M.DD.YYYY h:mm a',
  'MM.D.YYYY h:mm a',
  'M.D.YYYY h:mm a',
  'MMDDYYYY h:mm a',
  'MMM D YYYY h:mm a',
  'MMM DD YYYY h:mm a',
  'MMM D, YYYY h:mm a',
  'MMM DD, YYYY h:mm a',
  'MMDD hh:mm',
  'MM/DD hh:mm',
  'M/DD hh:mm',
  'MM/D hh:mm',
  'M/D hh:mm',
  'MM-DD hh:mm',
  'M-DD hh:mm',
  'MM-D hh:mm',
  'M-D hh:mm',
  'MM/DD/YY hh:mm',
  'M/DD/YY hh:mm',
  'MM/D/YY hh:mm',
  'M/D/YY hh:mm',
  'MM-DD-YY hh:mm',
  'M-DD-YY hh:mm',
  'MM-D-YY hh:mm',
  'M-D-YY hh:mm',
  'MM.DD.YY hh:mm',
  'M.DD.YY hh:mm',
  'MM.D.YY hh:mm',
  'M.D.YY hh:mm',
  'MMDDYY hh:mm',
  'MMM D hh:mm',
  'MMM DD hh:mm',
  'MMM D YY hh:mm',
  'MMM DD YY hh:mm',
  'MMM D, YY hh:mm',
  'MMM DD, YY hh:mm',
  'MM/DD/YYYY hh:mm',
  'M/DD/YYYY hh:mm',
  'MM/D/YYYY hh:mm',
  'M/D/YYYY hh:mm',
  'MM-DD-YYYY hh:mm',
  'M-DD-YYYY hh:mm',
  'MM-D-YYYY hh:mm',
  'M-D-YYYY hh:mm',
  'MM.DD.YYYY hh:mm',
  'M.DD.YYYY hh:mm',
  'MM.D.YYYY hh:mm',
  'M.D.YYYY hh:mm',
  'MMDDYYYY hh:mm',
  'MMM D YYYY hh:mm',
  'MMM DD YYYY hh:mm',
  'MMM D, YYYY hh:mm',
  'MMM DD, YYYY hh:mm',
  'MMDD h:mm',
  'MM/DD h:mm',
  'M/DD h:mm',
  'MM/D h:mm',
  'M/D h:mm',
  'MM-DD h:mm',
  'M-DD h:mm',
  'MM-D h:mm',
  'M-D h:mm',
  'MM/DD/YY h:mm',
  'M/DD/YY h:mm',
  'MM/D/YY h:mm',
  'M/D/YY h:mm',
  'MM-DD-YY h:mm',
  'M-DD-YY h:mm',
  'MM-D-YY h:mm',
  'M-D-YY h:mm',
  'MM.DD.YY h:mm',
  'M.DD.YY h:mm',
  'MM.D.YY h:mm',
  'M.D.YY h:mm',
  'MMDDYY h:mm',
  'MMM D h:mm',
  'MMM DD h:mm',
  'MMM D YY h:mm',
  'MMM DD YY h:mm',
  'MMM D, YY h:mm',
  'MMM DD, YY h:mm',
  'MM/DD/YYYY h:mm',
  'M/DD/YYYY h:mm',
  'MM/D/YYYY h:mm',
  'M/D/YYYY h:mm',
  'MM-DD-YYYY h:mm',
  'M-DD-YYYY h:mm',
  'MM-D-YYYY h:mm',
  'M-D-YYYY h:mm',
  'MM.DD.YYYY h:mm',
  'M.DD.YYYY h:mm',
  'MM.D.YYYY h:mm',
  'M.D.YYYY h:mm',
  'MMDDYYYY h:mm',
  'MMM D YYYY h:mm',
  'MMM DD YYYY h:mm',
  'MMM D, YYYY h:mm',
  'MMM DD, YYYY h:mm',
  'MMDD hh:mma',
  'MM/DD hh:mma',
  'M/DD hh:mma',
  'MM/D hh:mma',
  'M/D hh:mma',
  'MM-DD hh:mma',
  'M-DD hh:mma',
  'MM-D hh:mma',
  'M-D hh:mma',
  'MM/DD/YY hh:mma',
  'M/DD/YY hh:mma',
  'MM/D/YY hh:mma',
  'M/D/YY hh:mma',
  'MM-DD-YY hh:mma',
  'M-DD-YY hh:mma',
  'MM-D-YY hh:mma',
  'M-D-YY hh:mma',
  'MM.DD.YY hh:mma',
  'M.DD.YY hh:mma',
  'MM.D.YY hh:mma',
  'M.D.YY hh:mma',
  'MMDDYY hh:mma',
  'MMM D hh:mma',
  'MMM DD hh:mma',
  'MMM D YY hh:mma',
  'MMM DD YY hh:mma',
  'MMM D, YY hh:mma',
  'MMM DD, YY hh:mma',
  'MM/DD/YYYY hh:mma',
  'M/DD/YYYY hh:mma',
  'MM/D/YYYY hh:mma',
  'M/D/YYYY hh:mma',
  'MM-DD-YYYY hh:mma',
  'M-DD-YYYY hh:mma',
  'MM-D-YYYY hh:mma',
  'M-D-YYYY hh:mma',
  'MM.DD.YYYY hh:mma',
  'M.DD.YYYY hh:mma',
  'MM.D.YYYY hh:mma',
  'M.D.YYYY hh:mma',
  'MMDDYYYY hh:mma',
  'MMM D YYYY hh:mma',
  'MMM DD YYYY hh:mma',
  'MMM D, YYYY hh:mma',
  'MMM DD, YYYY hh:mma',
  'MMDD h:mma',
  'MM/DD h:mma',
  'M/DD h:mma',
  'MM/D h:mma',
  'M/D h:mma',
  'MM-DD h:mma',
  'M-DD h:mma',
  'MM-D h:mma',
  'M-D h:mma',
  'MM/DD/YY h:mma',
  'M/DD/YY h:mma',
  'MM/D/YY h:mma',
  'M/D/YY h:mma',
  'MM-DD-YY h:mma',
  'M-DD-YY h:mma',
  'MM-D-YY h:mma',
  'M-D-YY h:mma',
  'MM.DD.YY h:mma',
  'M.DD.YY h:mma',
  'MM.D.YY h:mma',
  'M.D.YY h:mma',
  'MMDDYY h:mma',
  'MMM D h:mma',
  'MMM DD h:mma',
  'MMM D YY h:mmaa',
  'MMM DD YY h:mma',
  'MMM D, YY h:mma',
  'MMM DD, YY h:mma',
  'MM/DD/YYYY h:mma',
  'M/DD/YYYY h:mma',
  'MM/D/YYYY h:mma',
  'M/D/YYYY h:mma',
  'MM-DD-YYYY h:mma',
  'M-DD-YYYY h:mma',
  'MM-D-YYYY h:mma',
  'M-D-YYYY h:mma',
  'MM.DD.YYYY h:mma',
  'M.DD.YYYY h:mma',
  'MM.D.YYYY h:mma',
  'M.D.YYYY h:mma',
  'MMDDYYYY h:mma',
  'MMM D YYYY h:mma',
  'MMM DD YYYY h:mma',
  'MMM D, YYYY h:mma',
  'MMM DD, YYYY h:mma',
  'MMDD hh a',
  'MM/DD hh a',
  'M/DD hh a',
  'MM/D hh a',
  'M/D hh a',
  'MM-DD hh a',
  'M-DD hh a',
  'MM-D hh a',
  'M-D hh a',
  'MM/DD/YY hh a',
  'M/DD/YY hh a',
  'MM/D/YY hh a',
  'M/D/YY hh a',
  'MM-DD-YY hh a',
  'M-DD-YY hh a',
  'MM-D-YY hh a',
  'M-D-YY hh a',
  'MM.DD.YY hh a',
  'M.DD.YY hh a',
  'MM.D.YY hh a',
  'M.D.YY hh a',
  'MMDDYY hh a',
  'MMM D hh a',
  'MMM DD hh a',
  'MMM D YY hh a',
  'MMM DD YY hh a',
  'MMM D, YY hh a',
  'MMM DD, YY hh a',
  'MM/DD/YYYY hh a',
  'M/DD/YYYY hh a',
  'MM/D/YYYY hh a',
  'M/D/YYYY hh a',
  'MM-DD-YYYY hh a',
  'M-DD-YYYY hh a',
  'MM-D-YYYY hh a',
  'M-D-YYYY hh a',
  'MM.DD.YYYY hh a',
  'M.DD.YYYY hh a',
  'MM.D.YYYY hh a',
  'M.D.YYYY hh a',
  'MMDDYYYY hh a',
  'MMM D YYYY hh a',
  'MMM DD YYYY hh a',
  'MMM D, YYYY hh a',
  'MMM DD, YYYY hh a',
  'MMDD h a',
  'MM/DD h a',
  'M/DD h a',
  'MM/D h a',
  'M/D h a',
  'MM-DD h a',
  'M-DD h a',
  'MM-D h a',
  'M-D h a',
  'MM/DD/YY h a',
  'M/DD/YY h a',
  'MM/D/YY h a',
  'M/D/YY h a',
  'MM-DD-YY h a',
  'M-DD-YY h a',
  'MM-D-YY h a',
  'M-D-YY h a',
  'MM.DD.YY h a',
  'M.DD.YY h a',
  'MM.D.YY h a',
  'M.D.YY h a',
  'MMDDYY h a',
  'MMM D h a',
  'MMM DD h a',
  'MMM D YY h a',
  'MMM DD YY h a',
  'MMM D, YY h a',
  'MMM DD, YY h a',
  'MM/DD/YYYY h a',
  'M/DD/YYYY h a',
  'MM/D/YYYY h a',
  'M/D/YYYY h a',
  'MM-DD-YYYY h a',
  'M-DD-YYYY h a',
  'MM-D-YYYY h a',
  'M-D-YYYY h a',
  'MM.DD.YYYY h a',
  'M.DD.YYYY h a',
  'MM.D.YYYY h a',
  'M.D.YYYY h a',
  'MMDDYYYY h a',
  'MMM D YYYY h a',
  'MMM DD YYYY h a',
  'MMM D, YYYY h a',
  'MMM DD, YYYY h a',
  'MMDD hh',
  'MM/DD hh',
  'M/DD hh',
  'MM/D hh',
  'M/D hh',
  'MM-DD hh',
  'M-DD hh',
  'MM-D hh',
  'M-D hh',
  'MM/DD/YY hh',
  'M/DD/YY hh',
  'MM/D/YY hh',
  'M/D/YY hh',
  'MM-DD-YY hh',
  'M-DD-YY hh',
  'MM-D-YY hh',
  'M-D-YY hh',
  'MM.DD.YY hh',
  'M.DD.YY hh',
  'MM.D.YY hh',
  'M.D.YY hh',
  'MMDDYY hh',
  'MMM D hh',
  'MMM DD hh',
  'MMM D YY hh',
  'MMM DD YY hh',
  'MMM D, YY hh',
  'MMM DD, YY hh',
  'MM/DD/YYYY hh',
  'M/DD/YYYY hh',
  'MM/D/YYYY hh',
  'M/D/YYYY hh',
  'MM-DD-YYYY hh',
  'M-DD-YYYY hh',
  'MM-D-YYYY hh',
  'M-D-YYYY hh',
  'MM.DD.YYYY hh',
  'M.DD.YYYY hh',
  'MM.D.YYYY hh',
  'M.D.YYYY hh',
  'MMDDYYYY hh',
  'MMM D YYYY hh',
  'MMM DD YYYY hh',
  'MMM D, YYYY hh',
  'MMM DD, YYYY hh',
  'MMDD h',
  'MM/DD h',
  'M/DD h',
  'MM/D h',
  'M/D h',
  'MM-DD h',
  'M-DD h',
  'MM-D h',
  'M-D h',
  'MM/DD/YY h',
  'M/DD/YY h',
  'MM/D/YY h',
  'M/D/YY h',
  'MM-DD-YY h',
  'M-DD-YY h',
  'MM-D-YY h',
  'M-D-YY h',
  'MM.DD.YY h',
  'M.DD.YY h',
  'MM.D.YY h',
  'M.D.YY h',
  'MMDDYY h',
  'MMM D h',
  'MMM DD h',
  'MMM D YY h',
  'MMM DD YY h',
  'MMM D, YY h',
  'MMM DD, YY h',
  'MM/DD/YYYY h',
  'M/DD/YYYY h',
  'MM/D/YYYY h',
  'M/D/YYYY h',
  'MM-DD-YYYY h',
  'M-DD-YYYY h',
  'MM-D-YYYY h',
  'M-D-YYYY h',
  'MM.DD.YYYY h',
  'M.DD.YYYY h',
  'MM.D.YYYY h',
  'M.D.YYYY h',
  'MMDDYYYY h',
  'MMM D YYYY h',
  'MMM DD YYYY h',
  'MMM D, YYYY h',
  'MMM DD, YYYY h',
  'MMDD hha',
  'MM/DD hha',
  'M/DD hha',
  'MM/D hha',
  'M/D hha',
  'MM-DD hha',
  'M-DD hha',
  'MM-D hha',
  'M-D hha',
  'MM/DD/YY hha',
  'M/DD/YY hha',
  'MM/D/YY hha',
  'M/D/YY hha',
  'MM-DD-YY hha',
  'M-DD-YY hha',
  'MM-D-YY hha',
  'M-D-YY hha',
  'MM.DD.YY hha',
  'M.DD.YY hha',
  'MM.D.YY hha',
  'M.D.YY hha',
  'MMDDYY hha',
  'MMM D hha',
  'MMM DD hha',
  'MMM D YY hha',
  'MMM DD YY hha',
  'MMM D, YY hha',
  'MMM DD, YY hha',
  'MM/DD/YYYY hha',
  'M/DD/YYYY hha',
  'MM/D/YYYY hha',
  'M/D/YYYY hha',
  'MM-DD-YYYY hha',
  'M-DD-YYYY hha',
  'MM-D-YYYY hha',
  'M-D-YYYY hha',
  'MM.DD.YYYY hha',
  'M.DD.YYYY hha',
  'MM.D.YYYY hha',
  'M.D.YYYY hha',
  'MMDDYYYY hha',
  'MMM D YYYY hha',
  'MMM DD YYYY hha',
  'MMM D, YYYY hha',
  'MMM DD, YYYY hha',
  'MMDD ha',
  'MM/DD ha',
  'M/DD ha',
  'MM/D ha',
  'M/D ha',
  'MM-DD ha',
  'M-DD ha',
  'MM-D ha',
  'M-D ha',
  'MM/DD/YY ha',
  'M/DD/YY ha',
  'MM/D/YY ha',
  'M/D/YY ha',
  'MM-DD-YY ha',
  'M-DD-YY ha',
  'MM-D-YY ha',
  'M-D-YY ha',
  'MM.DD.YY ha',
  'M.DD.YY ha',
  'MM.D.YY ha',
  'M.D.YY ha',
  'MMDDYY ha',
  'MMM D ha',
  'MMM DD ha',
  'MMM D YY haa',
  'MMM DD YY ha',
  'MMM D, YY ha',
  'MMM DD, YY ha',
  'MM/DD/YYYY ha',
  'M/DD/YYYY ha',
  'MM/D/YYYY ha',
  'M/D/YYYY ha',
  'MM-DD-YYYY ha',
  'M-DD-YYYY ha',
  'MM-D-YYYY ha',
  'M-D-YYYY ha',
  'MM.DD.YYYY ha',
  'M.DD.YYYY ha',
  'MM.D.YYYY ha',
  'M.D.YYYY ha',
  'MMDDYYYY ha',
  'MMM D YYYY ha',
  'MMM DD YYYY ha',
  'MMM D, YYYY ha',
  'MMM DD, YYYY ha',
  'MMDD HH',
  'MM/DD HH',
  'M/DD HH',
  'MM/D HH',
  'M/D HH',
  'MM-DD HH',
  'M-DD HH',
  'MM-D HH',
  'M-D HH',
  'MM/DD/YY HH',
  'M/DD/YY HH',
  'MM/D/YY HH',
  'M/D/YY HH',
  'MM-DD-YY HH',
  'M-DD-YY HH',
  'MM-D-YY HH',
  'M-D-YY HH',
  'MM.DD.YY HH',
  'M.DD.YY HH',
  'MM.D.YY HH',
  'M.D.YY HH',
  'MMDDYY HH',
  'MMM D HH',
  'MMM DD HH',
  'MMM D YY HH',
  'MMM DD YY HH',
  'MMM D, YY HH',
  'MMM DD, YY HH',
  'MM/DD/YYYY HH',
  'M/DD/YYYY HH',
  'MM/D/YYYY HH',
  'M/D/YYYY HH',
  'MM-DD-YYYY HH',
  'M-DD-YYYY HH',
  'MM-D-YYYY HH',
  'M-D-YYYY HH',
  'MM.DD.YYYY HH',
  'M.DD.YYYY HH',
  'MM.D.YYYY HH',
  'M.D.YYYY HH',
  'MMDDYYYY HH',
  'MMM D YYYY HH',
  'MMM DD YYYY HH',
  'MMM D, YYYY HH',
  'MMM DD, YYYY HH',
  'MMDD H',
  'MM/DD H',
  'M/DD H',
  'MM/D H',
  'M/D H',
  'MM-DD H',
  'M-DD H',
  'MM-D H',
  'M-D H',
  'MM/DD/YY H',
  'M/DD/YY H',
  'MM/D/YY H',
  'M/D/YY H',
  'MM-DD-YY H',
  'M-DD-YY H',
  'MM-D-YY H',
  'M-D-YY H',
  'MM.DD.YY H',
  'M.DD.YY H',
  'MM.D.YY H',
  'M.D.YY H',
  'MMDDYY H',
  'MMM D H',
  'MMM DD H',
  'MMM D YY H',
  'MMM DD YY H',
  'MMM D, YY H',
  'MMM DD, YY H',
  'MM/DD/YYYY H',
  'M/DD/YYYY H',
  'MM/D/YYYY H',
  'M/D/YYYY H',
  'MM-DD-YYYY H',
  'M-DD-YYYY H',
  'MM-D-YYYY H',
  'M-D-YYYY H',
  'MM.DD.YYYY H',
  'M.DD.YYYY H',
  'MM.D.YYYY H',
  'M.D.YYYY H',
  'MMDDYYYY H',
  'MMM D YYYY H',
  'MMM DD YYYY H',
  'MMM D, YYYY H',
  'MMM DD, YYYY H',
  'MMDD HH:mm',
  'MM/DD HH:mm',
  'M/DD HH:mm',
  'MM/D HH:mm',
  'M/D HH:mm',
  'MM-DD HH:mm',
  'M-DD HH:mm',
  'MM-D HH:mm',
  'M-D HH:mm',
  'MM/DD/YY HH:mm',
  'M/DD/YY HH:mm',
  'MM/D/YY HH:mm',
  'M/D/YY HH:mm',
  'MM-DD-YY HH:mm',
  'M-DD-YY HH:mm',
  'MM-D-YY HH:mm',
  'M-D-YY HH:mm',
  'MM.DD.YY HH:mm',
  'M.DD.YY HH:mm',
  'MM.D.YY HH:mm',
  'M.D.YY HH:mm',
  'MMDDYY HH:mm',
  'MMM D HH:mm',
  'MMM DD HH:mm',
  'MMM D YY HH:mm',
  'MMM DD YY HH:mm',
  'MMM D, YY HH:mm',
  'MMM DD, YY HH:mm',
  'MM/DD/YYYY HH:mm',
  'M/DD/YYYY HH:mm',
  'MM/D/YYYY HH:mm',
  'M/D/YYYY HH:mm',
  'MM-DD-YYYY HH:mm',
  'M-DD-YYYY HH:mm',
  'MM-D-YYYY HH:mm',
  'M-D-YYYY HH:mm',
  'MM.DD.YYYY HH:mm',
  'M.DD.YYYY HH:mm',
  'MM.D.YYYY HH:mm',
  'M.D.YYYY HH:mm',
  'MMDDYYYY HH:mm',
  'MMM D YYYY HH:mm',
  'MMM DD YYYY HH:mm',
  'MMM D, YYYY HH:mm',
  'MMM DD, YYYY HH:mm',
  'MMDD H:mm',
  'MM/DD H:mm',
  'M/DD H:mm',
  'MM/D H:mm',
  'M/D H:mm',
  'MM-DD H:mm',
  'M-DD H:mm',
  'MM-D H:mm',
  'M-D H:mm',
  'MM/DD/YY H:mm',
  'M/DD/YY H:mm',
  'MM/D/YY H:mm',
  'M/D/YY H:mm',
  'MM-DD-YY H:mm',
  'M-DD-YY H:mm',
  'MM-D-YY H:mm',
  'M-D-YY H:mm',
  'MM.DD.YY H:mm',
  'M.DD.YY H:mm',
  'MM.D.YY H:mm',
  'M.D.YY H:mm',
  'MMDDYY H:mm',
  'MMM D H:mm',
  'MMM DD H:mm',
  'MMM D YY H:mm',
  'MMM DD YY H:mm',
  'MMM D, YY H:mm',
  'MMM DD, YY H:mm',
  'MM/DD/YYYY H:mm',
  'M/DD/YYYY H:mm',
  'MM/D/YYYY H:mm',
  'M/D/YYYY H:mm',
  'MM-DD-YYYY H:mm',
  'M-DD-YYYY H:mm',
  'MM-D-YYYY H:mm',
  'M-D-YYYY H:mm',
  'MM.DD.YYYY H:mm',
  'M.DD.YYYY H:mm',
  'MM.D.YYYY H:mm',
  'M.D.YYYY H:mm',
  'MMDDYYYY H:mm',
  'MMM D YYYY H:mm',
  'MMM DD YYYY H:mm',
  'MMM D, YYYY H:mm',
  'MMM DD, YYYY H:mm',
];
